/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  
  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.mobile__menu__dropdown a.sliderow__title').forEach(item => {
    item.addEventListener('click', e => {
      document.querySelector('mobile-menu header-drawer').dispatchEvent(new CustomEvent("theme:drawer:close",{bubbles:!0}));
    });
  });
});